import axios, { isCancel } from 'axios'
import config from 'config'
import compact from 'lodash/compact'

const ApiError = function (message, code) {
  this.message = message
  this.code = code
}
ApiError.prototype = Error.prototype

export default (/* store */) => async ({ apiPath = '', withAuth = true, headers, ...rest }) => {
  const options = {
    url: config.apiURL + apiPath,
    withCredentials: withAuth,
    ...rest
  }

  try {
    const { data } = await axios(options)
    if (data.error) {
      throw new ApiError(data.error)
    }
    return data
  } catch (error) {
    if (isCancel(error)) {
      throw error
    }
    if (error.response && error.response.data && error.response.data.error) {
      const { text, description, code } = error.response.data.error
      throw new ApiError(compact([text, description]).join(' – '), code)
    }
    throw new ApiError(error.message)
  }
}
